import styled from 'styled-components';

export const TileContainer = styled.div`
  position: relative;
  width: 33%;
  height: 206px;

  background-color: var(--ds-surface-hovered, var(--ds-fb-surface-hovered));

  border-radius: 8px 8px 8px 8px;
  border: 1px solid;
  border-color: var(--ds-border, var(--ds-fb-border));
`;

export const ImageStyled = styled.img`
  position: absolute;
  max-width: 292px;
  top: 16px;
  right: 0px;
  bottom: 16px;
  width: calc(100% - 16px);
  height: calc(100% - 32px);
`;

export const LinkStyled = styled.div`
  position: absolute;
  bottom: 0;
  width: calc(100% - 16px);
  height: 48px;
  background-color: var(--ds-surface-overlay, var(--ds-fb-surface-overlay));

  border-radius: 0px 0px 8px 8px;
  border-top: 1px solid;
  border-color: var(--ds-border, var(--ds-fb-border));

  display: flex;
  align-items: center;
  padding-left: 16px;

  font-size: 14px;
  font-weight: 500;
`;

export const MarkStyled = styled.div`
  position: absolute;
  top: 0;
  padding: 8px 0px 0px 8px;
  z-index: 99;
`;
